import { render, staticRenderFns } from "./WorkflowTasks.vue?vue&type=template&id=e45a9c2e&scoped=true&"
import script from "./WorkflowTasks.vue?vue&type=script&lang=js&"
export * from "./WorkflowTasks.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowTasks.vue?vue&type=style&index=0&id=e45a9c2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45a9c2e",
  null
  
)

export default component.exports